export default "__VITE_ASSET__0556ff85__"